import React from "react";
import { Layout, Typography, Button, Row, Col, Card, Drawer, Flex, theme } from "antd";
import {
  WalletOutlined,
  FileTextOutlined,
  ShopOutlined,
  FileDoneOutlined,
  MenuOutlined,
} from "@ant-design/icons";
import { Link as RouterLink } from "react-router-dom";

const Landing: React.FC = () => {
  const [drawerVisible, setDrawerVisible] = React.useState(false);
  const { token } = theme.useToken();

  return (
    <Layout style={{ minHeight: '100vh', background: token.colorBgLayout }}>
      <Layout.Header style={{
        position: 'sticky',
        top: 0,
        zIndex: 50,
        width: '100%',
        background: token.colorBgContainer,
        backdropFilter: 'blur(12px)',
        borderBottom: `1px solid ${token.colorBorder}`,
        margin: '0 auto'
      }}>
        <Flex justify="space-between" >
          <Col style={{ paddingTop: '10px' }}>
            <Row align="middle" gutter={8}>
              <Col>
                <div
                  style={{
                    background: token.colorPrimary,
                    color: 'white',
                    padding: '6px',
                    borderRadius: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer'
                  }}
                >
                  <WalletOutlined style={{ fontSize: '20px' }} />
                </div>
              </Col>

              <Col>
                <Typography.Title
                  level={2}
                  style={{
                    color: token.colorPrimary,
                    fontSize: '18px',
                    fontWeight: 800,
                    lineHeight: 1.25,
                    letterSpacing: '-0.5px',
                    margin: 0
                  }}
                >
                  Billing app
                </Typography.Title>
              </Col>
            </Row>
          </Col>

          <Flex>
            {/* Menú desktop */}
            <Col xs={0} md="auto">
              <nav style={{ display: 'flex', gap: '24px' }}>
                <Typography.Link style={{ fontSize: '14px', fontWeight: 600 }}>
                  Funciones
                </Typography.Link>
                <Typography.Link style={{ fontSize: '14px', fontWeight: 600 }}>
                  Precios
                </Typography.Link>
                <Typography.Link style={{ fontSize: '14px', fontWeight: 600 }}>
                  Contacto
                </Typography.Link>
              </nav>
            </Col>

            {/* Botón login */}
            <Col>
              <RouterLink to="/login">
                <Button
                  type="primary"
                  style={{
                    padding: '8px 16px',
                    borderRadius: '8px',
                    fontSize: '14px',
                    fontWeight: 600,
                    boxShadow: '0 1px 2px rgba(0,0,0,0.1)'
                  }}
                >
                  Login
                </Button>
              </RouterLink>
            </Col>

            {/* Menú mobile */}
            <Col>
              <Button
                style={{ marginLeft: '10px' }}
                type="text"
                icon={<MenuOutlined />}
                onClick={() => setDrawerVisible(true)}
              />
            </Col>
          </Flex>
        </Flex>

      </Layout.Header>

      <Layout.Content style={{ padding: '64px 16px', maxWidth: '80rem', margin: '0 auto', position: 'relative', overflow: 'hidden' }}>
        {/* Hero Section */}
        <Row justify="center">
          <Col xs={24} style={{ textAlign: 'center', maxWidth: '48rem' }}>
            <div style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              background: token.colorPrimaryBg,
              color: token.colorPrimary,
              padding: '4px 12px',
              borderRadius: '9999px',
              fontSize: '12px',
              fontWeight: 'bold',
              textTransform: 'uppercase',
              letterSpacing: 'wider',
              marginBottom: '32px'
            }}>
              <div style={{ position: 'relative', display: 'flex', height: '8px', width: '8px' }}>
                <div style={{
                  position: 'absolute',
                  display: 'inline-flex',
                  height: '100%',
                  width: '100%',
                  borderRadius: '9999px',
                  background: token.colorPrimary,
                  opacity: 0.75,
                  animation: 'ping 1s cubic-bezier(0, 0, 0.2, 1) infinite'
                }}></div>
                <div style={{
                  position: 'relative',
                  display: 'inline-flex',
                  borderRadius: '9999px',
                  height: '8px',
                  width: '8px',
                  background: token.colorPrimary
                }}></div>
              </div>
              Nuevo: Dashboard 2.0
            </div>

            <Typography.Title level={1} style={{
              fontSize: 'clamp(2.25rem, 5vw, 4.5rem)',
              fontWeight: 'black',
              lineHeight: '1.1',
              letterSpacing: '-0.033em',
              marginBottom: '24px'
            }}>
              Administra tu negocio sin complicaciones
            </Typography.Title>

            <Typography.Text style={{
              fontSize: '18px',
              color: token.colorTextSecondary,
              fontWeight: 'normal',
              lineHeight: '1.625',
              display: 'block',
              marginBottom: '32px'
            }}>
              Crea facturas profesionales, gestiona contratos legales y organiza tus catálogos de productos en un solo lugar. La herramienta definitiva para PyMEs.
            </Typography.Text>

            <RouterLink to="/dashboard">
              <Button type="primary" style={{
                minWidth: '240px',
                height: '64px',
                padding: '0 32px',
                fontSize: '20px',
                fontWeight: 'bold',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                borderRadius: '12px'
              }}>
                Empieza hoy
              </Button>
            </RouterLink>
          </Col>
        </Row>

        <div style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '80%',
          height: '80%',
          background: token.colorPrimaryBg,
          borderRadius: '9999px',
          filter: 'blur(48px)',
          zIndex: -1
        }}></div>

        {/* Features Header */}
        <div style={{
          padding: '40px 0',
          background: token.colorBgContainer,
          borderTop: `1px solid ${token.colorBorder}`,
          borderBottom: `1px solid ${token.colorBorder}`,
          marginTop: '96px'
        }}>
          <Row justify="center">
            <Col xs={24} style={{ textAlign: 'center' }}>
              <Typography.Text style={{
                color: token.colorPrimary,
                fontSize: '14px',
                fontWeight: 'extrabold',
                textTransform: 'uppercase',
                letterSpacing: 'widest',
                display: 'block',
                marginBottom: '8px'
              }}>
                Nuestras Funcionalidades
              </Typography.Text>
              <Typography.Title level={2} style={{
                fontSize: '30px',
                fontWeight: 'black',
                marginBottom: '16px'
              }}>
                Todo lo que tu empresa necesita
              </Typography.Title>
              <div style={{
                width: '80px',
                height: '6px',
                background: token.colorPrimary,
                margin: '0 auto',
                borderRadius: '9999px'
              }}></div>
            </Col>
          </Row>
        </div>

        {/* Features Grid */}
        <Row gutter={[24, 24]} style={{ padding: '64px 0' }}>
          <Col xs={24} md={8}>
            <Card hoverable style={{
              borderRadius: '16px',
              border: '1px solid #dbdfe6',
              transition: 'all 0.3s'
            }} bodyStyle={{ padding: '32px' }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                <div style={{
                  width: '56px',
                  height: '56px',
                  borderRadius: '12px',
                  background: token.colorPrimaryBg,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: token.colorPrimary,
                  transition: 'all 0.3s'
                }}>
                  <FileTextOutlined style={{ fontSize: '36px' }} />
                </div>
                <div>
                  <Typography.Title level={3} style={{
                    fontSize: '20px',
                    fontWeight: 'extrabold',
                    lineHeight: '1.25',
                    marginBottom: '8px'
                  }}>
                    Facturación Inteligente
                  </Typography.Title>
                  <Typography.Text style={{
                    fontSize: '16px',
                    color: '#60728a',
                    lineHeight: '1.5'
                  }}>
                    Genera facturas legales, cotizaciones y recibos de forma automática. Olvídate de los errores manuales y cumple con las normativas locales.
                  </Typography.Text>
                </div>
              </div>
            </Card>
          </Col>

          <Col xs={24} md={8}>
            <Card hoverable style={{
              borderRadius: '16px',
              border: '1px solid #dbdfe6',
              transition: 'all 0.3s'
            }} bodyStyle={{ padding: '32px' }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                <div style={{
                  width: '56px',
                  height: '56px',
                  borderRadius: '12px',
                  background: token.colorPrimaryBg,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: token.colorPrimary,
                  transition: 'all 0.3s'
                }}>
                  <ShopOutlined style={{ fontSize: '36px' }} />
                </div>
                <div>
                  <Typography.Title level={3} style={{
                    fontSize: '20px',
                    fontWeight: 'extrabold',
                    lineHeight: '1.25',
                    marginBottom: '8px'
                  }}>
                    Gestión Multi-empresa
                  </Typography.Title>
                  <Typography.Text style={{
                    fontSize: '16px',
                    color: '#60728a',
                    lineHeight: '1.5'
                  }}>
                    Cambia entre diferentes razones sociales con un solo click. Reportes consolidados e inventarios compartidos para holdings o grupos empresariales.
                  </Typography.Text>
                </div>
              </div>
            </Card>
          </Col>

          <Col xs={24} md={8}>
            <Card hoverable style={{
              borderRadius: '16px',
              border: '1px solid #dbdfe6',
              transition: 'all 0.3s'
            }} bodyStyle={{ padding: '32px' }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                <div style={{
                  width: '56px',
                  height: '56px',
                  borderRadius: '12px',
                  background: token.colorPrimaryBg,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: token.colorPrimary,
                  transition: 'all 0.3s'
                }}>
                  <FileDoneOutlined style={{ fontSize: '36px' }} />
                </div>
                <div>
                  <Typography.Title level={3} style={{
                    fontSize: '20px',
                    fontWeight: 'extrabold',
                    lineHeight: '1.25',
                    marginBottom: '8px'
                  }}>
                    Control de Contratos
                  </Typography.Title>
                  <Typography.Text style={{
                    fontSize: '16px',
                    color: '#60728a',
                    lineHeight: '1.5'
                  }}>
                    Seguimiento detallado de vencimientos, renovaciones automáticas y firma digital integrada. Mantén tu legalidad al día sin esfuerzo.
                  </Typography.Text>
                </div>
              </div>
            </Card>
          </Col>
        </Row>

        {/* CTA Section */}
        <div style={{ padding: '80px 16px' }}>
          <Row justify="center">
            <Col xs={24} style={{ maxWidth: '64rem' }}>
              <Card style={{
                borderRadius: '32px',
                background: token.colorPrimary,
                padding: '32px',
                textAlign: 'center',
                color: 'white',
                position: 'relative',
                overflow: 'hidden'
              }} bodyStyle={{ padding: 0 }}>
                <div style={{
                  position: 'absolute',
                  inset: 0,
                  opacity: 0.1,
                  pointerEvents: 'none'
                }}>
                  <svg style={{ width: '100%', height: '100%', preserveAspectRatio: 'none' }} viewBox="0 0 100 100">
                    <path d="M0 100 L100 0 L100 100 Z" fill="white"></path>
                  </svg>
                </div>
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '32px',
                  alignItems: 'center',
                  position: 'relative',
                  zIndex: 10,
                  padding: '32px'
                }}>
                  <Typography.Title level={2} style={{
                    fontSize: 'clamp(1.875rem, 5vw, 3rem)',
                    fontWeight: 'black',
                    lineHeight: '1.1',
                    letterSpacing: 'tight',
                    color: 'white'
                  }}>
                    ¿Listo para optimizar tu negocio?
                  </Typography.Title>
                  <Typography.Text style={{
                    fontSize: '18px',
                    opacity: 0.9,
                    maxWidth: '32rem',
                    color: 'white'
                  }}>
                    Únete a más de 10,000 empresas que ya confían en nosotros para escalar su productividad y control financiero.
                  </Typography.Text>
                  <RouterLink to="/signup">
                    <Button type="default" style={{
                      minWidth: '240px',
                      height: '56px',
                      padding: '0 32px',
                      fontSize: '18px',
                      fontWeight: 'extrabold',
                      background: token.colorBgContainer,
                      color: token.colorPrimary,
                      border: 'none',
                      borderRadius: '12px',
                      boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)'
                    }}>
                      Comenzar hoy mismo
                    </Button>
                  </RouterLink>
                  <Typography.Text style={{ fontSize: '14px', opacity: 0.8, color: 'white' }}>
                    Sin tarjeta de crédito. Cancela cuando quieras.
                  </Typography.Text>
                </div>
              </Card>
            </Col>
          </Row>
        </div>
      </Layout.Content>

      <Layout.Footer style={{
        background: token.colorBgContainer,
        borderTop: `1px solid ${token.colorBorder}`,
        padding: '48px 16px',
        width:'100% !important',
        margin: '0 auto'
      }}>
        <Row gutter={[32, 32]}>
          <Col xs={24} md={12}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <Row align="middle" gutter={8}>
                <Col>
                  <div style={{
                    background: token.colorPrimary,
                    color: 'white',
                    padding: '4px',
                    borderRadius: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <WalletOutlined style={{ fontSize: '14px' }} />
                  </div>
                </Col>
                <Col>
                  <Typography.Title level={2} style={{
                    color: token.colorPrimary,
                    fontSize: '18px',
                    fontWeight: 'extrabold',
                    letterSpacing: 'tight',
                    margin: 0
                  }}>
                    Billing app
                  </Typography.Title>
                </Col>
              </Row>
              <Typography.Text style={{ fontSize: '14px', color: token.colorTextSecondary }}>
                Simplificando la gestión empresarial para el futuro digital.
              </Typography.Text>
            </div>
          </Col>

          <Col xs={12} md={6}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <Typography.Title level={5} style={{
                fontSize: '14px',
                fontWeight: 'bold',
                textTransform: 'uppercase',
                margin: 0
              }}>
                Producto
              </Typography.Title>
              <Typography.Link href="#" style={{ color: token.colorTextSecondary }}>Funciones</Typography.Link>
              <Typography.Link href="#" style={{ color: token.colorTextSecondary }}>Seguridad</Typography.Link>
              <Typography.Link href="#" style={{ color: token.colorTextSecondary }}>API</Typography.Link>
            </div>
          </Col>

          <Col xs={12} md={6}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <Typography.Title level={5} style={{
                fontSize: '14px',
                fontWeight: 'bold',
                textTransform: 'uppercase',
                margin: 0
              }}>
                Compañía
              </Typography.Title>
              <Typography.Link href="#" style={{ color: token.colorTextSecondary }}>Nosotros</Typography.Link>
              <Typography.Link href="#" style={{ color: token.colorTextSecondary }}>Blog</Typography.Link>
              <Typography.Link href="#" style={{ color: token.colorTextSecondary }}>Carreras</Typography.Link>
            </div>
          </Col>

          <Col xs={12} md={6}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <Typography.Title level={5} style={{
                fontSize: '14px',
                fontWeight: 'bold',
                textTransform: 'uppercase',
                margin: 0
              }}>
                Soporte
              </Typography.Title>
              <Typography.Link href="#" style={{ color: token.colorTextSecondary }}>Ayuda</Typography.Link>
              <Typography.Link href="#" style={{ color: token.colorTextSecondary }}>Privacidad</Typography.Link>
              <Typography.Link href="#" style={{ color: token.colorTextSecondary }}>Contacto</Typography.Link>
            </div>
          </Col>
        </Row>


      </Layout.Footer>

      <Drawer
        title="Menu"
        placement="right"
        onClose={() => setDrawerVisible(false)}
        open={drawerVisible}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <Typography.Link href="#" style={{ fontSize: '16px' }}>Funciones</Typography.Link>
          <Typography.Link href="#" style={{ fontSize: '16px' }}>Precios</Typography.Link>
          <Typography.Link href="#" style={{ fontSize: '16px' }}>Contacto</Typography.Link>
          <RouterLink to="/login">
            <Button type="primary" style={{ width: '100%' }}>Login</Button>
          </RouterLink>
        </div>
      </Drawer>
    </Layout>
  );
};

export default Landing;
